import React, {Component} from "react";
import * as PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {
    dismissErrorAlert,
    getPollAssignment,
    submitPollResponse,
    UPDATE_POLL_RESPONSE
} from "../../actions/pollPortal/pollPortalAction";
import isEmpty from "../../helpers/isEmpty";
import {DefaultBtn, RadioInput, SmallLoader} from "Ncontracts.Common.UI";
import {imageCdnUrls} from "../common/ImageCdnUrls";
import "./_style.scss";
import ErrorAlert from "../common/ErrorAlert";

class PollPortal extends Component {

    static propTypes = {
        dismissError: PropTypes.func,
        getPollAssignment: PropTypes.func,
        match: PropTypes.object,
        pollAssignment: PropTypes.object,
        selectedOptionId: PropTypes.string,
        showErrorAlert: PropTypes.bool,
        showSuccessMessage: PropTypes.bool,
        submitResponse: PropTypes.func,
        updateResponse: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.props.getPollAssignment();
    }

    handleSubmitClick = () => {
        const {selectedOptionId} = this.props;
        this.props.submitResponse({selectedOptionId: selectedOptionId});
    };

    successMessage = () => {
        return (
            <div className="success-message">
                <div className="success-icon">
                    <img src={imageCdnUrls.complete_initiative} width="75" height="75"/>
                </div>
                <div className="message-text">Poll answer successfully submitted!</div>
            </div>);
    };

    render() {
        const {dismissError, pollAssignment, showSuccessMessage, selectedOptionId, showErrorAlert} = this.props;
        if (isEmpty(pollAssignment)) return <div className="poll-portal"><SmallLoader/></div>;

        const {customerName, title, message, question, options} = pollAssignment;
        const optionsList = isEmpty(options) ? undefined : options.map(o => {
            return (
                <div className="option" key={o.id}>
                    <RadioInput key={o.id} id={o.id} value={o.id} checked={o.id === selectedOptionId}
                                onChange={e => this.props.updateResponse(e.currentTarget.value)}>
                        {o.text}
                    </RadioInput>
                </div>);
        });

        return (
            <div className="poll-portal">
                <div className="customer-name">{customerName}</div>
                {showSuccessMessage ? this.successMessage() :
                    <div className="poll-form">
                        <div className="communications-icon">
                            <img src={imageCdnUrls.communications} width="193" height="140"/>
                        </div>
                        <div className="communication-title">{title}</div>
                        <div className="communication-message">{message}</div>
                        <div className="question">{question}</div>
                        <div className="options">{optionsList}</div>
                        <div className="submit-button">
                            <DefaultBtn className="btn--default btn--wide" disabled={isEmpty(selectedOptionId)}
                                        onClick={this.handleSubmitClick}>Submit</DefaultBtn>
                        </div>
                    </div>
                }
                <div className="portal-footer">
                    <div className="powered-by">Powered By</div>
                    <div className="nc-logo"><img src={imageCdnUrls.logoContractsBlue} width="133" height="26"/></div>
                </div>
                {(showErrorAlert) ? <ErrorAlert dismissHandler={dismissError}/> : undefined}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    pollAssignment: state.pollPortal.pollAssignment,
    showSuccessMessage: state.pollPortal.pollResponseSuccessfullySaved,
    selectedOptionId: state.pollPortal.selectedOptionId,
    showErrorAlert: state.pollPortal.showErrorAlert
});

const mapDispatchToProps = dispatch => ({
    dismissError: () => dispatch(dismissErrorAlert()),
    getPollAssignment: () => dispatch(getPollAssignment()),
    submitResponse: pollData => dispatch(submitPollResponse(pollData)),
    updateResponse: optionId => dispatch({type: UPDATE_POLL_RESPONSE, optionId: optionId})
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PollPortal));
